import { Component, OnInit, Inject, Input, Output, ViewEncapsulation, AfterViewInit } from '@angular/core';

import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { SelectedAssuranceComponent } from '../selected-assurance/selected-assurance.component';

import { CustomParameterComponent } from '../custom-parameter/custom-parameter.component';

import { GestockService } from '../services/gestock.service';
import { ServicepoolService } from '../services/servicepool.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { ConfirmsouscriptionComponent } from '../confirmsouscription/confirmsouscription.component';

import { ViewChild, TemplateRef } from '@angular/core';

import {MatProgressBarModule} from '@angular/material/progress-bar';

import {MatDatepickerInputEvent} from '@angular/material/datepicker';

import { formatDate } from "@angular/common";

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

import { FactureComponent } from '../facture/facture.component';

@Component({
  selector: 'app-detailsclientcrm',
  templateUrl: './detailsclientcrm.component.html',
  styleUrls: ['./detailsclientcrm.component.css']
})
export class DetailsclientcrmComponent implements OnInit, AfterViewInit {

 nomprofil : any ;
 retourClientWS : any ;

 allHabilitations : any ;
 allReportingAccess: any ;

 etatreq = "" ;

  toggle = [] ;
  toggle2  = [] ;
  verroux = [] ;

  allProfils : any ;

  allGlobalvarfin = [] ;

  toggleProfil  = [] ;
  subBlock = 0 ;

  choosenSupHierarch : any ;

  idsuphierarchique : any;

  idprofil : any ;

  primarycolor = "primary" ;//"#3f51b5" ;

  datedeb : any ;
  datefin : any ;
  allDetailedTransacts: any ;

  nbreCmds : any ;
  revenus : any ;
  dataSource : any ;


  client =   {
    nom: 'Modou Seck',
    dernierAchat: new Date('2025-04-15'),
    moyenne10j: 120,
    panierMoyen: 40,
    caPeriodique: 360,
    benefice: 90
  } ;


  hereAreYourHabilitatations = [] ;
  hereAreYourReportAccess = [] ;
  hereAreYourComplianceRules = [] ;

  hereIsYourCanal : any ;
  lesCanaux : any ;

  leCanalPrivilegie : any ;


  choosenId = -1 ;    

  valeur : any ;

  dataSourceCompliance : MatTableDataSource<any> ;

  displayedColumns: string[] = ['prenom', 'nom', 'telephone', 'numpolice', 'immatriculation', 'dateexpiration', 'etat' ];

  rules = [] ;


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  compositionFormComm = [] ;

  allCommandes : any ;


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;


  @ViewChild('confirmdialog') confirmDialog: TemplateRef<any>;
  confirmDialogRef : any ;

  userDetails : any ;

  statutrelance : any ;

  qualifications = ['A Rappeler', 'Rappelé', 'Renouvelé', 'Perdu'] ;

  samacaabiyoonwii : any ;

  edit = 0 ;

  constructor(public dialogRef: MatDialogRef<DetailsclientcrmComponent>, public dialog: MatDialog,
         private configServer: ServicepoolService, private configServerGestock: GestockService,
  				private _adapter: DateAdapter<any>, @Inject(MAT_DATE_LOCALE) private _locale: string,
  				@Inject(MAT_DIALOG_DATA) public data: any ) {

    this.datedeb = new Date(); 
    this.datefin = new Date();    

    this.userDetails = data.leClient ;    
    //this.dataSource =  new MatTableDataSource(data.details) ;

  }


  ngOnInit(): void {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    let profil = sessionStorage.getItem("profil") ;
    this.statutrelance = this.userDetails.statutrelance ;
    this.getCommandesClientBii();
  }

  ngAfterViewInit() {
  }

  getDateFormatFrench(datebi){
    if(datebi!=undefined){
      let datebiDoug = new Date(datebi) ;
      let weerwi = datebiDoug.toLocaleString('fr-FR', { month: 'long' });
      let jourBi = datebiDoug.getDate() ;
      let anneeBi = datebiDoug.getFullYear() ;
      return jourBi+" "+weerwi+" "+anneeBi ;
    }else
      return "" ;
  }

  choosedInStatuts(i){
    this.statutrelance = this.qualifications[i] ;
  }

  isActif(dateexpiration){
    const currentDate = formatDate(new Date(), "yyyy-MM-dd", 'en-US') ;
  return dateexpiration  >= currentDate ;
  }

  getCommandesClientBii(){

    this.configServerGestock.getReportingClientBi( this.samacaabiyoonwii, this.userDetails.id).then( (retourbi) => {

        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;

        if(statutrec==1){
          this.allCommandes = this.retourClientWS.data ;
        }
        else{
          this.allCommandes  = [] ;
            console.log("Failed") ;
        }
    }) ;        
  }

  getParsed(val){
    return JSON.parse(val);
  }


  updateStatutClient(){

    this.openSpinnerDialog();

    this.configServer.updateStatutClient( this.samacaabiyoonwii, this.userDetails.id, this.statutrelance).then( (retourbi) => {

        this.closeSpinnerDialog() ;
        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;

        if(statutrec==1){
		  this.userDetails.statutrelance = this.statutrelance ;
	     this.etatreq = "successful" ;
        }
        else{
	        this.etatreq = "failed" ;
            console.log("Failed") ;
        }
    }) ;      	
  }

  getHistoWaadjii(){
    this.getAllTransactsByDateInterval() ;
  }


  getAllTransactsByDateInterval(){

    var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

    this.configServer.getReportingDashbordPourKii(this.samacaabiyoonwii, debut, fin, this.userDetails.id).then( (retourbi) => {
      // console.log(retourbi);
      this.retourClientWS = retourbi ;
        console.log("Done") ;
        this.allDetailedTransacts = this.retourClientWS.data ;
        console.log(this.allDetailedTransacts) ;
        
        this.nbreCmds = this.allDetailedTransacts.length ;
        this.revenus = this.totalCmds(this.allDetailedTransacts) ;

        this.dataSource =  new MatTableDataSource(this.allDetailedTransacts) ;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
     
    }) ; 
  }

  totalCmds(ListCommands){
    let  total : number = 0 ;
    for (var i = ListCommands.length - 1; i >= 0; i--) {
      total = total + parseInt( ListCommands[i].primeTTC) ;
     }
     return total ;
  }


  getMontantFormatee(montant){
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd ;
  }


  close(){
    this.dialogRef.close();
  }

  getAllCanals(){  

    this.configServer.getAllCanals("samacaabiyoonwi").then( (retourbi) => {

        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;

        if(statutrec==1){
          console.log("Done") ;
          this.lesCanaux = this.retourClientWS.data ;
          console.log(this.lesCanaux) ;
        }
        else
          console.log("Failed") ;
    }) ;    
  }


  choosedInSelectCanal(slctdInsType){
    this.leCanalPrivilegie  = this.lesCanaux[slctdInsType] ;
    this.hereIsYourCanal = this.leCanalPrivilegie.nom ;
  }

  getAllHabilitations(){
    console.log("Here we go !!!") ;
    this.configServer.getAllHabilitations("thiswii").then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        this.allHabilitations = this.retourClientWS.data.habilitation ; 
        this.allReportingAccess = this.retourClientWS.data.reportaccess ; 

        for (var i = 0; i < this.allHabilitations.length; i++) {
          let oneHabilitationState = {"nom":this.allHabilitations[i].nom, "idhabilit":this.allHabilitations[i].idlignehabilit, "etat": 0 };
          this.hereAreYourHabilitatations.push(oneHabilitationState) ;
        }        


        for (var i = 0; i < this.allReportingAccess.length; i++) {
          let oneReportHabilitationState = {"nom":this.allReportingAccess[i].nom, "idhabilit":this.allReportingAccess[i].idlignehabilit, "etat": 0 };
          this.hereAreYourReportAccess.push(oneReportHabilitationState) ;
        }        

      }
      else{
        console.log("Failed") ;
      }
    }) ;      	
  }


  onrulesChange(event){
    this.valeur = "" ;
    let choosenIndex = event.value ;    
    if(choosenIndex!=-1){
      this.choosenId = choosenIndex ;       
    }
  }


  saveOperation(){
    let theRule = this.rules[this.choosenId] ;
    let isIn = false ;
    theRule.valeur = this.valeur ;
    for (var i = 0; i < this.hereAreYourComplianceRules.length; i++) {
      if(this.hereAreYourComplianceRules[i].name==theRule.name){
        this.hereAreYourComplianceRules[i] = theRule ;
        isIn = true ;
        break;
      }
    }

    if(isIn==false)
      this.hereAreYourComplianceRules.push(theRule) ;

    this.dataSourceCompliance =  new MatTableDataSource(this.hereAreYourComplianceRules) ;
  }

  confirmerOperation(){
	this.closeConfirmDialog() ;
  	if(this.subBlock==0){
  		console.log("sauvegarde globale !") ;
  		this.valideretsauvegarder()
  	}

  	if(this.subBlock==1){
  		console.log("Reinitialisation Confirmée !") ;
  		this.yeessalaatCaabiWaadji()
  	}
  	if(this.subBlock==21){
  		this.soppandietatwoucomptebi()
  		console.log("Désactiver Compte !") ;
  	}
  	if(this.subBlock==22){
  		this.soppandietatwoucomptebi()
  		console.log("Activer Compte !") ;
  	}  	

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filterPredicate = (data, filter) => {
      return JSON.stringify(data).toLowerCase().includes(filter);
    };
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }



  valideretsauvegarder(){
    this.openSpinnerDialog();
    this.configServer. updateUserdetails(this.samacaabiyoonwii, this.hereIsYourCanal, this.hereAreYourComplianceRules, this.userDetails.id).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;

      this.closeSpinnerDialog() ;
      if(statutreq==1){
        this.etatreq = "successful" ;
      }
      else{
        this.etatreq = "failed" ;
        console.log("Failed") ;
      }
    }) ;    
  }




  yeessalaatCaabiWaadji(){  

  	this.openSpinnerDialog();

    this.configServer.yeessalaatCaabiWaadji(this.samacaabiyoonwii, this.userDetails.id).then( (retourbi) => {

	  	this.closeSpinnerDialog();

        this.retourClientWS = retourbi ;
        var statutreq = this.retourClientWS.statutreq ;
        console.log("Back There with : ", this.retourClientWS.data) ;
        if(statutreq==1){
          this.etatreq="successful" ;
        }
        else
          this.etatreq="failed" ;

    }) ;    
  }
  

  soppandietatwoucomptebi(){  
  	let etat = 0 ;
  	if(this.subBlock==21)
  		etat = 0 ;
  	if(this.subBlock==22)
  		etat = 1 ;

  	this.openSpinnerDialog();

    this.configServer.soppandietatwoucomptebi(this.samacaabiyoonwii, this.userDetails.id, etat).then( (retourbi) => {

	  	this.closeSpinnerDialog();

        this.retourClientWS = retourbi ;
        var statutreq = this.retourClientWS.statutreq ;
        console.log("Back There with : ", this.retourClientWS.data) ;
        if(statutreq==1){
           this.userDetails.actif = etat ;
          this.etatreq="successful" ;
        }
        else
          this.etatreq="failed" ;

    }) ;    
  }

  getAllProfils(){
    this.configServer.getAllProfils("thissamacaabiyoonwii").then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.getAllGlobalVarFin() ;
        console.log(this.retourClientWS.data ) ;
        console.log("Done") ;
        this.allProfils = this.retourClientWS.data ; 
	    this.setChoosenProfilSup() ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }

  setChoosenProfilSup(){
  	console.log(this.allProfils) ;
  	console.log(this.idsuphierarchique);

  	for (var i = 0; i < this.allProfils.length; i++) {
  		if(this.allProfils[i].idprofil==this.idsuphierarchique)
  			this.choosenSupHierarch = this.allProfils[i] ;
  	}

  }

  getThePrimaryColor(idInProfil){
    if(this.choosenSupHierarch!=undefined){
      let valuReturn = this.choosenSupHierarch.idprofil==idInProfil ? this.primarycolor:'' ;
      return valuReturn ;      
    }

    return "" ;      
  }


  clickOnThis(ind){
    if(this.hereAreYourHabilitatations[ind].etat == 1){
      for (var i = 0 ; i <this.hereAreYourHabilitatations.length; i++) {
        console.log("Adding ...") ;
        if(i==ind){
          this.hereAreYourHabilitatations[i].etat = 0;
        }
      }
    }else{
      for (var i = 0 ; i <this.hereAreYourHabilitatations.length; i++) {
        console.log("Removing ...") ;
        if(i==ind){
          this.hereAreYourHabilitatations[i].etat = 1;
        }
      }
    }
  }


  getAllGlobalVarFin(){  
    this.configServer.getAllGlobalVarFin("fguuy").then( (retourbi) => {
        this.retourClientWS = retourbi ;
        var statutrec = this.retourClientWS.statutreq ;
        console.log("Back There with : ", this.retourClientWS.data) ;
        this.compositionFormComm = [] ;
        this.compositionFormComm.push( "Prime Nette" ) ; 
        if(statutrec==1){
          //this.getAllCanals() ;
          this.allGlobalvarfin = this.retourClientWS.data ;
          for (var i = 0; i < this.allGlobalvarfin.length; i++) {
            this.compositionFormComm.push( this.allGlobalvarfin[i].nomvariable ) ;
          }
        }
        else
          console.log("Failed") ;

        console.log("At the end of the day: ", this.compositionFormComm) ;


    }) ;    
  }


  copyThisArray(arrayToCopy){
    var copyArray = [] ;
    for (var i = 0; i< arrayToCopy.length; i++) {
      let objBi =  {"nomFrmt": this.formatThisString(arrayToCopy[i]), "intitule": arrayToCopy[i], "type":"custompredefval"}   ;
      copyArray.push(objBi) ;
    }
    return copyArray ;
  }

  formatThisString(name){
    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }


  configPrime(){

    var choosenParams = [] ;

    choosenParams =  this.copyThisArray(this.compositionFormComm) ;

    this.openDialogForPrimeConfig(this.rules[this.choosenId].name, 1, choosenParams, JSON.parse(this.getByKeyName(this.hereAreYourComplianceRules, "Commission").valeur) ) ;
  }


  getByKeyName(tab, name){
    for (var i = 0; i < tab.length; i++) {
      if(tab[i].name == name )
        return tab[i] ;
    }
     return {"valeur": "[]"} ;
  }


  openDialogForPrimeConfig(nomPrime, typeIndex, params, laFormule) {
    console.warn('Prime configuration dialog is unavailable (component removed).', {
      nomPrime,
      typeIndex,
      params,
      laFormule
    });
  }



  clickOnThisRep(ind){
    if(this.hereAreYourReportAccess[ind].etat == 1){
      for (var i = 0 ; i <this.hereAreYourReportAccess.length; i++) {
        console.log("Adding ...") ;
        if(i==ind){
          this.hereAreYourReportAccess[i].etat = 0;
        }
      }
    }else{
      for (var i = 0 ; i <this.hereAreYourReportAccess.length; i++) {
        console.log("Removing ...") ;
        if(i==ind){
          this.hereAreYourReportAccess[i].etat = 1;
        }
      }
    }
  }


  openConfirmDialog() {
    this.confirmDialogRef = this.dialog.open(this.confirmDialog);
  }

  closeConfirmDialog() {
    this.confirmDialogRef.close();
  }

  clickOnThisProfil(ind){
    this.choosenSupHierarch = this.allProfils[ind];
  }

  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }



}
